import React from "react";
import { Trash2 } from "lucide-react";

const TodoItem = ({ todo, index, theme, screenSize, t, onToggle, onDelete }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: screenSize.isMobile ? 12 : 14,
        borderRadius: 14,
        background: todo.completed
          ? theme === "dark"
            ? "linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(5, 150, 105, 0.05))"
            : "linear-gradient(135deg, rgba(16, 185, 129, 0.06), rgba(5, 150, 105, 0.03))"
          : theme === "dark"
          ? "linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))"
          : "linear-gradient(145deg, #ffffff, #f8fafc)",
        border:
          theme === "dark"
            ? `2px solid ${
                todo.completed
                  ? "rgba(16, 185, 129, 0.25)"
                  : "rgba(255,255,255,0.08)"
              }`
            : `2px solid ${
                todo.completed
                  ? "rgba(16, 185, 129, 0.2)"
                  : "rgba(0,0,0,0.06)"
              }`,
        marginBottom: screenSize.isMobile ? 6 : 8,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        animation: `slideIn 0.3s ease ${index * 0.05}s both`,
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateX(-4px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateX(0)";
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "4px",
          background: todo.completed
            ? "linear-gradient(180deg, #2e7cba, #2e7cba)"
            : "transparent",
          borderRadius: "0 4px 4px 0",
        }}
      />

      <div
        onClick={() => onToggle(todo.id)}
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "8px",
          border: `2.5px solid ${
            todo.completed
              ? "#2e7cba"
              : theme === "dark"
              ? "rgba(255,255,255,0.25)"
              : "rgba(0,0,0,0.25)"
          }`,
          background: todo.completed
            ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
            : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.3s ease",
          flexShrink: 0,
        }}
      >
        {todo.completed && (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M11 4L5.5 9.5L3 7"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>

      <div
        style={{
          flex: 1,
          fontSize: screenSize.isMobile ? 14 : 15,
          fontWeight: 600,
          color: todo.completed
            ? theme === "dark"
              ? "rgba(255,255,255,0.35)"
              : "rgba(0,0,0,0.35)"
            : theme === "dark"
            ? "#fff"
            : "#1a1a1a",
          textDecoration: todo.completed ? "line-through" : "none",
          wordBreak: "break-word",
        }}
      >
        {todo.text}
      </div>

      <button
        onClick={() => onDelete(todo.id)}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "10px",
          background:
            "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))",
          border: "1px solid rgba(239, 68, 68, 0.2)",
          color: "#ef4444",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.3s ease",
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, rgba(239, 68, 68, 0.25), rgba(220, 38, 38, 0.15))";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <Trash2 size={screenSize.isMobile ? 14 : 16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default TodoItem;
